(ns assemble.assets-page.db
  (:require [assemble.assets-page.drawer.db]
            [assemble.component.file-tree.db]
            [re-frame.core :as rf]))

(rf/reg-event-fx :assemble.assets-page/copy-to-clipboard
  (fn [_ [_ content]]
    {:content->clipboard {:content content
                          :success #(rf/dispatch [:toaster-bus/add {:id ::copied->clipboard
                                                                    :type :success
                                                                    :message "Copied to clipboard"}])
                          :error #(rf/dispatch [:toaster-bus/add {:id ::copied->clipboard
                                                                  :type :error
                                                                  :message "Could not copy to clipboard"}])}}))
